export default __webpack_public_path__ + "static/education-9145508518e6a11cbea3a837755232fd.png";